import {
  CHART_HEX_INTERACTIVE,
  CHART_HEX_SUPPORT_SUCCESS,
  formatDateFrDay2MonthShort,
  formatDateFrMedium,
} from '@sphere/shared/util'
import { LineChartWrapper } from '../shared'

export interface DailyActivity {
  date: string
  attempt_count: number
  active_users: number
  avg_score: number
}

export interface EstablishmentDailyActivityChartProps {
  data: DailyActivity[]
}

export function EstablishmentDailyActivityChart({
  data,
}: EstablishmentDailyActivityChartProps) {
  if (!data || data.length === 0) {
    return null
  }

  return (
    <LineChartWrapper
      data={data}
      dataKey="attempt_count"
      lines={[
        {
          dataKey: 'attempt_count',
          name: 'Tentatives',
          stroke: CHART_HEX_INTERACTIVE,
          strokeWidth: 2,
        },
        {
          dataKey: 'active_users',
          name: 'Utilisateurs actifs',
          stroke: CHART_HEX_SUPPORT_SUCCESS,
          strokeWidth: 2,
        },
      ]}
      xAxisKey="date"
      title="Activité quotidienne"
      height={300}
      xAxisFormatter={value => formatDateFrDay2MonthShort(value as string)}
      tooltipLabelFormatter={label => formatDateFrMedium(label as string)}
    />
  )
}
